module.exports = __webpack_public_path__ + "img/p70.cdf85ef6.jpg";